export default "__VITE_ASSET__DZ$BxITq__"